







































































import { ButtonType } from '@getaccept/lib-ui';
import { sanitizeEmail, validateEmail } from '@getaccept/lib-shared/src/helpers';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { PropType } from '@vue/composition-api';
import { onMounted, computed, ref, defineComponent } from '@vue/composition-api';
import { AfterSignStep } from '../../../types/enums/after-sign-step';
import type { AfterSign as IAfterSign } from '../../../types/after-sign';
import PoweredByLogo from '../../../assets/powered-by-ga.svg';
import AfterSignCreateSignup from './AfterSignCreateSignup.vue';
import AfterSignFeedback from './AfterSignFeedback.vue';
import AfterSignOptions from './AfterSignOptions.vue';
import AfterSignFeedbackComplete from './AfterSignFeedbackComplete.vue';
import AfterSignCreateSignupComplete from './AfterSignCreateSignupComplete.vue';

export default defineComponent({
  components: {
    AfterSignCreateSignup,
    AfterSignFeedback,
    AfterSignOptions,
    AfterSignFeedbackComplete,
    AfterSignCreateSignupComplete,
    PoweredByLogo,
  },
  props: {
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
    afterSign: {
      type: Object as PropType<IAfterSign>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const emailInput = ref('');
    const feedbackInput = ref('');

    const showActionButtons = computed(
      (): boolean =>
        currentStep.value !== AfterSignStep.Init &&
        currentStep.value !== AfterSignStep.FeedbackComplete
    );

    const validEmail = computed(
      (): boolean => emailInput.value.length > 0 && validateEmail(emailInput.value.toLowerCase())
    );

    const recipientEmail = computed((): string => props.recipient.email?.toLowerCase() || '');

    const showCancelButton = computed(
      (): boolean =>
        currentStep.value !== AfterSignStep.SignupComplete &&
        currentStep.value !== AfterSignStep.FeedbackComplete
    );

    const currentStep = computed((): AfterSignStep => props.afterSign.step);

    const cleanEmail = computed((): string => sanitizeEmail(emailInput.value));

    const handleChangeStep = (step: AfterSignStep) => {
      emit('changeStep', step);
    };

    const handleSelect = (option: AfterSignStep) => {
      handleChangeStep(option);
      emit('response', option);
    };

    const handleEmail = (email: string) => {
      emailInput.value = sanitizeEmail(email);
    };

    const handleFeedback = (feedback: string) => {
      feedbackInput.value = feedback;
    };

    const handleSendFeedback = () => {
      emit('feedback', feedbackInput.value, cleanEmail.value);
      handleChangeStep(AfterSignStep.FeedbackComplete);
    };

    const handleSignup = () => {
      emit('signup', cleanEmail.value);
    };

    const handleClose = () => {
      emit('close');
    };

    onMounted(() => {
      emailInput.value = recipientEmail.value;
    });

    return {
      AfterSignStep,
      ButtonType,
      emailInput,
      feedbackInput,
      showActionButtons,
      validEmail,
      recipientEmail,
      showCancelButton,
      currentStep,
      cleanEmail,
      handleChangeStep,
      handleSelect,
      handleEmail,
      handleFeedback,
      handleSendFeedback,
      handleSignup,
      handleClose,
    };
  },
});
